import { Worker } from "@react-pdf-viewer/core";
import { App as AntApp, ConfigProvider } from "antd";
import { Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import CustomEmpty from "./components/ui/CustomEmpty";
import Loader from "./components/ui/Loader";
import { antdThemeConfig } from "./constants/config";
import { pdfWorkerURL } from "./constants/constants";
import useAppBoot from "./hooks/useAppBoot";
import useFilterReset from "./hooks/useFilterReset";
import { publicRouters, sidebarRouters } from "./routers/routers";

export default function App() {
  const [isLoading, setIsLoading] = useState(true);
  const { loading, navigateUrl } = useAppBoot();
  useFilterReset();

  useEffect(() => {
    const t = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(t);
  }, []);

  return (
    <Worker workerUrl={pdfWorkerURL}>
      <ConfigProvider
        theme={antdThemeConfig}
        renderEmpty={() => <CustomEmpty rootClassName="py-20" />}
      >
        <AntApp>
          {loading || isLoading ? (
            <Loader />
          ) : (
            <Routes>
              <Route path="/" element={<Navigate to={navigateUrl} />} />
              <Route path="/admin" element={<Navigate to={navigateUrl} />} />
              <Route
                path="/dashboard"
                element={<Navigate to={navigateUrl} />}
              />

              {/* Public routers */}
              {publicRouters.map(({ path, element: Element }, idx) => (
                <Route
                  path={path}
                  key={idx + path}
                  element={
                    <Suspense fallback={<Loader />}>
                      <Element />
                    </Suspense>
                  }
                />
              ))}

              {/* sidebar routers */}
              {sidebarRouters.map(({ path, element: Element, roles }, idx) => (
                <Route
                  path={path}
                  key={path + idx}
                  element={
                    <PrivateRoute roles={roles}>
                      <Suspense fallback={<Loader />}>
                        <Element />
                      </Suspense>
                    </PrivateRoute>
                  }
                />
              ))}
            </Routes>
          )}
        </AntApp>
      </ConfigProvider>
    </Worker>
  );
}
